// src/models/produtos/Produto.js
import { Grupo } from './Grupo';
import { Marca } from './Marca';
import { DestaqueProduto } from './DestaqueProduto';
import { UnMedida } from './UnMedida';


export class Produto {
    constructor() {
        this.id = 0;
        this.descricao = "";
        this.grupo = new Grupo();
        this.marca = new Marca();
        this.unTrib = "";
        this.unMedida = new UnMedida();        
        //this.imagem = new Imagem();
        this.alteraDescricao = false;
        this.precoFixo = true;
        this.preco = null;       
        this.custoUltimo = null; 
        this.custoMedio = null;            
        this.estoque = null;
        this.movEstoque = true;
        this.estoqueMin = null;

        this.inativo = null;
        this.orderNum = null;

        //Impostos
        this.ncm = null;
        this.cfop = null;
        this.csosn = null;
        this.cstPisCofinsEnt = null;
        this.cstPisCofinsSai = null;
        this.cest = null;
        this.ean = null;

        //Serviço
        this.ehServico = false;
        this.cTribNac = null;
        this.cTribMun = null;
        this.nbs = null;
        this.tribIssqn = null;
        this.aliquotaIss = null;
        this.cstPisCofinsServico = null;
        this.aliquotaPis = null;
        this.aliquotaCofins = null;
        this.cstIbsCbs = null;
        this.cClassTribIbsCbs = null;
        this.cIndOpIbsCbs = null;

        //Delivery
        this.ingredientes = null;
        this.produtoVariacoes = [];
        this.destaqueProdutoId = null;
        this.destaqueProduto = new DestaqueProduto();
        this.usarRolagem = null;
        this.cashBackPercent = null;
        this.imprimirIngredientes = false;
    }
}
